import { DownloadSimple } from '@phosphor-icons/react';
import { Button } from 'src/v2/commonComponents/Button';
import { SVG_SIZE_M } from 'src/constants';
import { ToggleProps } from 'src/v2/commonComponents/DrawerTooltipContainer';

interface DownloadFileTriggerProps extends ToggleProps {
  toolType?: 'message' | 'editor';
}

export const DownloadFileTrigger = ({
  id,
  isActive,
  disabled,
  onClick,
  toolType,
}: DownloadFileTriggerProps) => {
  const isMessageTool = toolType === 'message';
  const defaultColor = isMessageTool ? 'secondary-outline' : 'transparent';

  return (
    <div id={id}>
      <Button
        onClick={onClick}
        shape={isMessageTool ? 'regular' : 'round'}
        color={isActive ? 'tertiary' : defaultColor}
        disabled={disabled}
        tooltipContent="Download to your device in your preferred file format"
        tooltipPlace="top"
      >
        <DownloadSimple size={SVG_SIZE_M} />

        {isMessageTool && <span>Download</span>}
      </Button>
    </div>
  );
};
